import { useMutation, useQueryClient } from "@tanstack/react-query";
import { patchJobAction } from "../actions/patchJob.action";
import { useGlobalSnackbar } from "src/context/SnackbarContext";

export const usePatchJob = () => {
    const { showSnackbar } = useGlobalSnackbar();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (variables: { jobId: string | number; payload: any }) => patchJobAction(variables.jobId, variables.payload),
        onSuccess: () => {
            showSnackbar("Job updated successfully", "success");
            queryClient.invalidateQueries({ queryKey: ["jobs"] });
            queryClient.invalidateQueries({ queryKey: ["job"] });
        },
        onError: (error: any) => {
            showSnackbar(error?.response?.data?.message || "Failed to update job", "error");
        }
    });
}